import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const Predictions = () => {
  return (
    <div>
      <Title level={2}>🏆 Race Predictions</Title>
      <Card>
        <p>Advanced race prediction analysis coming soon...</p>
      </Card>
    </div>
  );
};

export default Predictions;

